<template>



  <!--  ==============================  MODAL_SECTION START ============================== -->
  <b-modal
    id="modal-add-brigade"
    :title="editMode == true ?  $t('edition') : $t('add_brigade')"
    cancel-variant="outline-secondary"
    :ok-title="editMode == true ? $t('general.edit') : $t('general.add')"
    ok-variant="success"
    :cancel-title="$t('general.close')"
    centered
    no-close-on-backdrop
    @cancel="onCancel"
    @close="onCancel"
    @show="showModal"
    @ok="onSubmitMoney"
  >
    <b-form>
      <validation-observer ref="moneyValidations">


        <b-form-group :label="$t('namee')">
          <validation-provider
            #default="{ errors }"
            :name="$t('namee')"
            rules="required"
          >
            <b-form-input v-model="title" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>


      </validation-observer>
    </b-form>
  </b-modal>
  <!--  ==============================  MODAL_SECTION END ============================== -->


  
</template>

<script>
import { BModal, VBModal, BForm, BFormInput, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    editBrigade: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {




      // ===============  PRIMARY_DATA_SECTION START ===============
      title: "",
      editMode: false,
      // ===============  PRIMARY_DATA_SECTION END ===============




    };
  },
  methods: {
    ...mapActions("brigade", [
      "CREATE_BRIGADE",
      "UPDATE_PUT_BRIGADE",
    ]),





    // ===============  ON_SHOW_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode
      
      if (!this.editBrigade) {
        return;
      }

      if (typeof this.editBrigade === "object" && this.editBrigade !== null) {
        this.title = this.editBrigade.title;
      }
    },
    // ===============  ON_SHOW_SECTION END ===============





    onCancel(){
      this.$route.params.editMode = false
    },
    onClose(){
      this.$route.params.editMode = false
    },




    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitMoney(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.moneyValidations.validate().then((success) => {
        if (!success) {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }

        try {
          if (this.editBrigade.id) {
            this.UPDATE_PUT_BRIGADE({
              id: this.editBrigade.id,
              title: this.title,
            }).then(async () => {
              await this.$parent.refresh()
            });
          } else {
            this.CREATE_BRIGADE({title: this.title}).then(async () => {
              await this.$parent.refresh()
            });
          }
          this.$nextTick(() => {
            this.$route.params.editMode = false
            this.$bvModal.hide("modal-add-brigade");
          });

          this.title = ""

          this.$_okToast();
        } catch (err) {
          this.$_errToast(err);
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============





  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
